import { useHistory } from "react-router-dom";
import tw from "src/utils/tw";

interface Props {
  className?: string;
  backText?: string;
  to?: string;
  onClick?: () => void;
}

export default function BackButton(props: Props) {
  const history = useHistory();

  function onClick() {
    if (props.onClick) {
      props.onClick();
    } else if (props.to) {
      history.push(props.to);
    } else if (history.length > 1) {
      history.goBack();
    } else {
      history.push("/");
    }
  }

  return (
    <button
      onClick={onClick}
      className={tw("block text-sm text-empty", props.className)}
    >
      <i aria-hidden className="far fa-circle-arrow-left mr-1" />{" "}
      {props.backText || "Previous"}
    </button>
  );
}
